module.exports = __webpack_public_path__ + "static/media/не.83829c06.mp3";